<template>
  <div id="app" :class="themeClass">
    <app-header></app-header>

    <main class="main">
      <slot></slot>
    </main>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'

export default {
  name: 'public-layout',

  components: {
    AppHeader,
    AppFooter
  },

  props: {
    theme: {
      type: String,
      required: false
    }
  },

  computed: {
    themeClass () {
      return this.theme ? `theme-${this.theme}` : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/PublicLayout.vue